import { styled } from '@mui/material/styles';

export const StyledServiceTabs = styled('div')`
  display: flex;
  align-items: center;
  background: #f4f5f7;
  border: 0.5px solid rgba(30, 22, 78, 0.16);
  border-radius: 12px;
  padding: 4px;

  .service-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: rgba(28, 28, 30, 0.64);
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;
    border: none;
    background: none;
    font-family: inherit;

    &:hover {
      color: rgba(28, 28, 30, 0.8);
    }

    &.active {
      background: #ffffff;
      color: #1c1c1e;
      box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.08);
    }
  }
`;
